import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import { IPesquisaVendedores, defValueVendedor } from "../../types/api/geral/pesquisar-vendedores";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";

export default function SelectVendedores({
    value,
    required = false,
    error = false,
    errorMessage = undefined,
    onChange
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false);

    const handleClose = () => setOpenModal(false);

    const inputLabel = value ? `${value.nome}` : "";

    return (
        <>
            <TextField
                {...{ required, error }}
                label={`Vendedor`}
                variant="outlined"
                fullWidth
                onClick={() => setOpenModal(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: { readOnly: true }
                }}
                value={inputLabel}
                helperText={error ? errorMessage : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose }}
                        title="Selecionar vendedor"
                        queryPath="/pesquisar-vendedores"
                        getItemKey={(item) => item.id}
                        getItemLabel={(item) => `${item.nome}`}
                        defaultValue={value || defValueVendedor}
                        onChange={(value) => {
                            onChange(value as IPesquisaVendedores);
                            handleClose();
                        }}
                    />
                </Dialog>
            }
        </>
    );
}

interface SelectSimpleApiQueryProps {
    value: IPesquisaVendedores | null | undefined;
    onChange: (arg: IPesquisaVendedores | null) => void;
    required?: boolean;
    error?: boolean;
    errorMessage?: string | undefined;
}